module.exports = __webpack_public_path__ + "media/images/icons/v2/users-01-d0d5ee3eab9c029951b8900ef3101fa2.svg";